import React from 'react';
import { Link } from 'react-router-dom';

const ModelFamily = () => {
  return (
    <section className="mb-16">
      <h2 className="text-3xl font-bold text-gray-800 mb-6">ASI1 Model Family</h2>
      <p className="text-gray-700 leading-relaxed mb-8">
        The ASI1 family offers specialized models designed for different use cases and performance requirements, each optimized for specific aspects of agentic AI and Web3 applications.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <Link to="/mini-model" className="group">
          <div className="bg-gray-50 p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow group-hover:bg-blue-50">
            <h3 className="text-lg font-semibold text-blue-700 mb-3 group-hover:text-blue-800">ASI1 Mini</h3>
            <p className="text-gray-700">
              General-purpose model for everyday agentic workflows and Web3 applications.
            </p>
          </div>
        </Link>

        <Link to="/fast-model" className="group">
          <div className="bg-gray-50 p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow group-hover:bg-blue-50">
            <h3 className="text-lg font-semibold text-blue-700 mb-3 group-hover:text-blue-800">ASI1 Fast</h3>
            <p className="text-gray-700">
              Ultra-low latency model for real-time applications and instant agent discovery.
            </p>
          </div>
        </Link>

        <Link to="/graph-model" className="group">
          <div className="bg-gray-50 p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow group-hover:bg-blue-50">
            <h3 className="text-lg font-semibold text-blue-700 mb-3 group-hover:text-blue-800">ASI Graph</h3>
            <p className="text-gray-700">
              Specialized for data visualization and turning numbers into comprehensible visuals.
            </p>
          </div>
        </Link>

        <Link to="/extended-model" className="group">
          <div className="bg-gray-50 p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow group-hover:bg-blue-50">
            <h3 className="text-lg font-semibold text-blue-700 mb-3 group-hover:text-blue-800">ASI1 Mini-Extended</h3>
            <p className="text-gray-700">
              Enhanced reasoning capabilities for complex analysis and deep audits.
            </p>
          </div>
        </Link>

        <Link to="/voice-model" className="group">
          <div className="bg-gray-50 p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow group-hover:bg-blue-50">
            <h3 className="text-lg font-semibold text-blue-700 mb-3 group-hover:text-blue-800">ASI Voice</h3>
            <p className="text-gray-700">
              Conversational AI optimized for voice interactions and natural dialogue.
            </p>
          </div>
        </Link>

        <Link to="/finance-expert-agent" className="group">
          <div className="bg-gray-50 p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow group-hover:bg-green-50">
            <h3 className="text-lg font-semibold text-green-700 mb-3 group-hover:text-green-800">ASI Finance Expert</h3>
            <p className="text-gray-700">
              Specialized agent for financial analysis and DeFi applications.
            </p>
          </div>
        </Link>
      </div>
    </section>
  );
};

export default ModelFamily;
